import { render, staticRenderFns } from "./FilePreviewModal.vue?vue&type=template&id=780366b5&scoped=true&"
import script from "./FilePreviewModal.vue?vue&type=script&lang=js&"
export * from "./FilePreviewModal.vue?vue&type=script&lang=js&"
import style0 from "./FilePreviewModal.vue?vue&type=style&index=0&id=780366b5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "780366b5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/otavio.cardoso.neto/Workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('780366b5')) {
      api.createRecord('780366b5', component.options)
    } else {
      api.reload('780366b5', component.options)
    }
    module.hot.accept("./FilePreviewModal.vue?vue&type=template&id=780366b5&scoped=true&", function () {
      api.rerender('780366b5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FileExplorer/FilePreviewModal.vue"
export default component.exports